import React from 'react';
import { Check, X } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function ForWhoSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const forYou = ['te culpas si trabajas y te culpas si no', 'sientes que nunca alcanza', 'estás cansada de vivir "compensando"', 'quieres paz práctica, no discursos'];
  const notForYou = ['buscas un proceso clínico profundo aquí mismo', 'no estás dispuesta a hacer 10 minutos diarios por 14 días'];
  return <section ref={ref} className="w-full bg-white py-10 px-6 md:py-14" data-id="element-28">
      <div className={`max-w-4xl mx-auto fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-29">
        {/* Investment context */}
        <div className="text-center mb-8 max-w-2xl mx-auto" data-id="element-30">
          <p className="font-sans text-lg text-text-dark leading-relaxed" data-id="element-31">
            Si trabajaras este tema en sesiones individuales, la inversión sería
            mucho mayor.
            <br data-id="element-32" />
            <span className="font-medium text-navy" data-id="element-33">
              Aquí tienes una estructura completa por menos de lo que cuesta una
              salida simple.
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-34">
          {/* For You */}
          <div className="bg-cream/50 p-6 rounded-xl border border-gold/20" data-id="element-35">
            <h3 className="font-serif text-2xl text-navy font-bold mb-4 flex items-center gap-2" data-id="element-36">
              <span className="bg-green-100 text-green-700 p-1 rounded-full" data-id="element-37">
                <Check className="w-5 h-5" data-id="element-38" />
              </span>
              Esto es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-39">
              {forYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-40">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-41" />
                  <span className="font-sans text-text-dark" data-id="element-42">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-43">
            <h3 className="font-serif text-2xl text-text-muted font-bold mb-4 flex items-center gap-2" data-id="element-44">
              <span className="bg-gray-200 text-gray-500 p-1 rounded-full" data-id="element-45">
                <X className="w-5 h-5" data-id="element-46" />
              </span>
              No es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-47">
              {notForYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-48">
                  <X className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-49" />
                  <span className="font-sans text-text-muted" data-id="element-50">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Description between sections */}
        <div className="mt-8 text-center max-w-2xl mx-auto" data-id="element-51">
          <p className="font-serif text-xl text-navy italic leading-relaxed" data-id="element-52">
            Este material está diseñado para madres responsables, funcionales y
            comprometidas que están cansadas de exigirse todo el tiempo.
          </p>
        </div>
      </div>
    </section>;
}